<template>
    <div class="widget-inner">
        <template v-if="isPersonalDashboardWidget">
            <div class="widget-empty-message" v-if="!entries.length">
                <div :style="{color}">
                    {{widget.emptyMessage}}
                </div>
            </div>
            <ul class="widget-content" v-else>
                <li v-for="entry in entries" :class="['flex', {'bottom-border': needsBottomBorder(entry)}]">
                    <div class="text-overflow">
                        <router-link :to="entry.link" v-if="entry.link">{{entry.title}}</router-link>
                        <router-link v-else :to="{name: widget.viewRoute, params: entry}">{{entry.title}}</router-link>
                        <small v-if="!content.ownFAQs">
                            <template v-if="entry.created">
                                {{dateHelper('d.m.Y', entry.created)}}
                            </template>
                            <template v-if="entry.creator">
                                von {{getUsername(entry.creator)}}
                            </template>
                        </small>
                    </div>
                    <div v-if="content.ownFAQs" class="flex flex--item-right no-select">
                        <i v-tooltip :class="['material-icons', entry.has_reply ? 'text-warning' : 'text-danger']" role="img" aria-hidden="true"
                            :title="entry.has_reply ? 'Diese Frage hat noch keine als richtig markierte Antwort.' : 'Diese Frage hat noch keine Antwort.'">
                            {{entry.has_reply ? 'help' : 'info'}}
                        </i>
                    </div>
                </li>
            </ul>

            <router-link v-if="content.hasMore" :to="widget.defaultRoute" class="flex margin-right-10 margin-bottom-3">
                <div class="text-overflow flex--item-right text-underline">
                    <span>Alle ansehen</span>
                    <i class="material-icons small-icon" aria-hidden="true" role="img">open_in_new</i>
                </div>
            </router-link>
        </template>
        <template v-else>
            <div class="widget-empty-message" v-if="!entries.length">
                <i class="material-icons md-96" aria-hidden="true" role="img">{{widget.emptyIcon}}</i>
                <br/>
                {{widget.emptyMessage}}
            </div>
            <ul class="widget-content" v-else>
                <li class="flex"
                    :class="{'background-today': isToday(entry.created)}"
                    v-for="entry in entries">
                    <div class="text-overflow">
                        <router-link :to="entry.link" v-if="entry.link">{{entry.title}}</router-link>
                        <router-link v-else :to="{name: widget.viewRoute, params: entry}">{{entry.title}}</router-link>
                        <small>
                            <template v-if="entry.created">
                                {{dateHelper('d.m.Y', entry.created)}}
                            </template>
                            <template v-if="entry.creator">
                                von {{getUsername(entry.creator)}}
                            </template>
                        </small>
                    </div>
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts">
    import {WidgetDefault} from '@/components/widgets/WidgetDefault.vue';
    import {getUsername} from '../../filters/username';
    import {Component, Prop} from 'vue-facing-decorator';
    import dateHelper, {isToday} from '../../utils/portuna/dateHelper';

    interface IFAQWidgetEntry
    {
        created: string;
        creator: number;
        id: number;
        has_helpful_reply: number;
        has_reply: number;
        link: string;
        title: string;
    }

    @Component({
        name: 'WidgetFAQ',
        methods: {
            dateHelper,
            isToday,
            getUsername,
        },
    })
    export default class WidgetFAQ extends WidgetDefault
    {
        @Prop({
            type: Object,
            required: true,
        }) widget: WidgetData;

        @Prop({
            type: Object,
            required: true,
        }) content: WidgetContentProp;

        get entries(): IFAQWidgetEntry[]
        {
            return this.content.entries as IFAQWidgetEntry[];
        }

        needsBottomBorder(entry: IFAQWidgetEntry): boolean
        {
            return this.isPersonalDashboardWidget
                && (
                    this.content.hasMore
                    || entry !== this.content.entries![this.content.entries!.length - 1]
                );
        }
    }
</script>